import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import API from '../../../axios/api';
import axios from "axios";
import { i18n } from '../../../translate/i18n';
import * as actions from "../../../store/actions";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachIcon from '@mui/icons-material/AttachFile';
import { withRouter } from 'react-router-dom'

import {
  Container, Paper, Typography, IconButton, TextField, FormControl, Input, Dialog, DialogContent,
} from '@mui/material';

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../Forms/styles';

import Upload from '../../../UI/Upload';
import FileList from '../../../UI/FileList';
import confirm from '../../../UI/Confirm/confirm';
import Spinner from '../../../components/Spinner/index';
import resizeFile from '../../../utils/imageResizer';
import { map as asyncMap } from 'p-iteration';

const ModalAction = (props) => {
  const dispatch = useDispatch();

  // parametros para busca do autocomplete
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const [isNewData, setIsNewData] = useState(true);
  const [editMode, setEditMode] = useState(false);

  const [actionError, setActionError] = useState(false);
  const [usersError, setUsersError] = useState(false);
  const [documentTypesError, setDocumentTypesError] = useState(false);
  const [uploadSubmitError, setUploadSubmitError] = useState(false)
  const [uploadEmptyFileError, setUuploadEmptyFileError] = useState(false)

  const [actionText, setActionText] = useState('');
  const [deadline, setDeadline] = useState(new Date());
  const [uploadedFiles, setUploadedFiles] = useState([]);

  // selected values on autocomplete
  const [selectedUsers, setSelectedUsers] = React.useState({});

  const [searchTextUsers, setSearchTextUsers] = useState("")

  const [usersFormated, setUsersFormated] = useState([])

  // fetch from BE
  const fetchUsers = useCallback(
    () => dispatch(actions.fetchValidUsers(page, limit, searchTextUsers, order, orderBy)),
    [page, limit, searchTextUsers, order, orderBy]
  );
  const fetchEquipment = useCallback(
    (id) => dispatch(actions.fetchActionsById(id))
  );

  const postActions = (body) => dispatch(actions.postActions(body))


  //get from redux
  const users = useSelector(state => state.users.users);
  const action = useSelector(state => state.actions.action);

  //post to BE
  const loadingUsers = useSelector(state => state.users.loading);
  const loadingAction = useSelector(state => state.actions.loading);


  //FUNCTION TO FORMAT FIELD OF ACTIVITIES AND AREAS TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = users
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setUsersFormated(returnArray)
  }, [users])


  useEffect(() => {
    fetchUsers(page, limit, searchTextUsers, order, orderBy);
  }, [searchTextUsers]);

  const handleInputChangeSelectorUsers = (text) => {
    setSearchTextUsers(text);
  }

  const handleInputChangeUsers = selected => {
    setUsersError(false);
    setSelectedUsers(selected)
  }

  //check if is newEntrance or editing
  useEffect(() => {
    if (props.open) {
      if (props.actionId !== 'new') {
        setActionText(props.editModalData.actionText);
        setSelectedUsers({value: props.editModalData.accountable._id, label: props.editModalData.accountable.name})
        setDeadline(props.editModalData.deadline)
        setIsNewData(false);
        setEditMode(false);
      } else {
        setActionText("");
        setSelectedUsers({});
        setUploadedFiles([]);
        setDeadline(new Date())
        setIsNewData(true);
      }
    }
  }, [props.open])

  const handleSubmit = async e => {
    e.stopPropagation();
    e.preventDefault();
    let hasError = false;

    if (!actionText) {
      setActionError(true);
      hasError = true
    }


    const notUploaded = uploadedFiles.filter(fl => fl.isNotUploaded)
    if (notUploaded.length > 0) {
      setUploadSubmitError(true)
      hasError = true;
    }

    const filesIds = []

    uploadedFiles.map(fl => {
      if (fl.id)
        return filesIds.push(fl.id)
      else if (fl._id)
        return filesIds.push(fl._id)
    });

    if (hasError) return;

    let body = {
      actionText: actionText,
      status: 'progress',
      deadline: deadline,
      accountable: { _id: selectedUsers.value, name: selectedUsers.label },
      files: filesIds,
      question: props.question._id,
      questionText: props.question.name,
      questionGroupName: props.question.groupId?.name,
    };

    // se tem um responsavel, vai add ele
    if (!isEmpty(selectedUsers)) {
      body.accountable = { _id: selectedUsers.value, name: selectedUsers.label }
    }

    if(!props.actionShouldPost) { // se for false, vai fazer chamada no BE para criar
      if (isNewData) {
        body._id = uniqueId();
        dispatch(actions.addActionToQuestionServiceForm(body))
      } else {
        console.log('props.editModalData._id', props.editModalData._id);
        dispatch(actions.editActionToQuestionServiceForm(props.editModalData._id, body))
      }
      props.onClose();

    } else {
      const bodyToPost = {
        actionText: body.actionText,
        status: body.status,
        deadline: body.deadline,
        accountable: body.accountable._id,
        files: body.files,
        question: props.question.questionsId, // nao eh a questao clonada, eh a questao da collection question
        questionText: props.question.name,
        questionGroupName: props.question.groupName,
        service: props.match.params.id, // precisa pegar o id do service da url
      }

      if (!isEmpty(selectedUsers)) {
        body.accountable = body.accountable._id
      }

      postActions(bodyToPost).then(res => {
        if (res !== 'error') {
          body._id = res._id
          dispatch(actions.addActionToQuestionServiceForm(body))
          props.onClose();
        }
      })
    }
  }

  const handleDateChange = date => {
    setDeadline(date);
  }

  const handleUpload = async files => {
    const uploadingFiles = await asyncMap(files, async (file) => {
      const fileOptimized = await resizeFile(file)

      return ({
        file: fileOptimized,
        id: uniqueId(),
        name: fileOptimized.name,
        readableSize: filesize(fileOptimized.size),
        preview: URL.createObjectURL(fileOptimized),
        fileType: fileOptimized.type,
        progress: 0,
        isNotUploaded: true,
        error: false,
        url: null
      });
    });

    setUploadedFiles(prevUf => prevUf.concat(uploadingFiles))
    uploadingFiles.forEach(processUpload);
  };

  const updateFile = (id, data) => {
    setUploadedFiles(prevUf => prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf))
  };


  const processUpload = async uploadedFile => {

    API.post("files/signurl", { file: uploadedFile }).then(signUrlRes => {

      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile.id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `files/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("files", body)
          .then(response => {
            setUploadSubmitError(false)
            updateFile(uploadedFile.id, {
              isNotUploaded: false,
              id: response.data._id,
              url: response.data.url,
              loading: false,
              error: false,
            });
          })
          .catch(() => {
            updateFile(uploadedFile._id, {
              error: true,
              loading: false,
            });
          });
      })
    })
  }

  const handleDelete = async id => {
    try {
      await API.delete(`files/${id}`)
      setUploadedFiles(prevUf => prevUf.filter(file => file.id !== id && file._id !== id))

    } catch (e) {
      console.log('e', e);
    }
  }

  const handleDeleteDocument = (documentId) => {
    confirm(i18n.t('handleDeleteDocumentModalAction.confirm'),
      {
        title: i18n.t('handleDeleteDocumentModalAction.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          dispatch(actions.deleteActionToQuestionService(props.editModalData));
          props.onClose();
          // deleteAddDocumentCompanies(company._id, documentId)
        },
      )
  }

  const handleDeleteDocumentFile = (id) => {
    if (!editMode && !isNewData) return;
    confirm(i18n.t('handleDeleteDocumentFileModalAction.confirm'),
      {
        title: i18n.t('handleDeleteDocumentFileModalAction.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          handleDelete(id)
        },
      )
  }

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      scroll='body'
      open={props.open}
      onClose={() => props.onClose()}
    >
      <FormStyled onSubmit={handleSubmit} style={{ ...styles.opacityContainer, opacity: loadingAction ? '0.3' : '1' }}>
      {loadingAction && <Spinner overlay />}
        <DivFormTitle>
          <Typography variant='h6'>{isNewData ? i18n.t('typographyModalAction.true') : i18n.t('typographyModalAction.false')}</Typography>
          {!isNewData &&
            <DivSubmitButtons>
              {editMode ?
                <>
                  <IconButton onClick={() => props.onClose()} size="large"><CloseIcon color='error' /></IconButton>
                  <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                </> :
                <>
                  <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                  <IconButton onClick={() => handleDeleteDocument(props.editModalData)} size="large"><DeleteIcon /></IconButton>
                </>
              }
            </DivSubmitButtons>
          }
        </DivFormTitle>

        <Typography style={styles.question}>{props.question.name}</Typography>

        <FormControl variant="standard" fullWidth>
          <TextField
            variant="standard"
            autoFocus
            multiline
            disabled={!isNewData && !editMode}
            label={i18n.t('textFieldModalFilter.action')}
            name='action'
            onChange={event => { setActionError(false); return setActionText(event.target.value.toUpperCase()) }}
            value={actionText}
            error={actionError}
            margin='normal' />
        </FormControl>

        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingUsers} //sent to isLoading
            label={i18n.t('autocompleteModalAction.user')}
            data={usersFormated} // sent to options
            onSelectValue={handleInputChangeUsers} // sent to onChange
            valueSelected={selectedUsers} // sent to value
            newSearchText={handleInputChangeSelectorUsers}
            name='funcao'
            hasError={usersError}
            disabled={!isNewData && !editMode}
          />
        </FormControl>

        <DatePicker
          required
          label={i18n.t('keyboardDatePicker.deadline')}
          margin='normal'
          value={new Date(deadline)}
          onChange={date => handleDateChange(date)}
          minDate={new Date()}
          format="dd/MM/yyyy"
          disabled={!isNewData && !editMode}
          slotProps={{ textField: { variant: 'standard', } }}
        />

        <div style={styles.sectionTitleContainer}>
          <AttachIcon style={{ color: (!isNewData && !editMode) ? 'lightgrey' : '#000' }} />
          <Typography style={{ color: (!isNewData && !editMode) ? 'lightgrey' : '#000' }}>{i18n.t('typographyModalAction.text')}</Typography>
        </div>
        <Upload onUpload={handleUpload} disabled={!isNewData && !editMode} />
        {!!uploadedFiles.length && (
          <FileList files={uploadedFiles} onDelete={handleDeleteDocumentFile} disabled={!editMode && !isNewData} />
        )}
        {uploadSubmitError && <div style={styles.fileError}>{i18n.t('divModalAction.fileError')}</div>}

        {isNewData &&
          <DivSubmitButtons>
            <IconButton onClick={() => props.onClose()} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
            <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
          </DivSubmitButtons>
        }

      </FormStyled>
    </Dialog>
  );
}

export default withRouter(ModalAction);


const styles = {
  container: {
    padding: '10px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  print: {
    marginRight: 5,
  },
  contentContainer: {
    margin: '30px 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  opacityContainer: {
    position: 'relative'
  },
  fileError: {
    color: '#f44336'
  },
  question: {
    marginTop: 20,
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
}
